export { pushAdClickData } from 'next-flight-server-reference-proxy-loader?id=709c49feb7b22b5775fc64768c4fe25aca8605e949&name=pushAdClickData!'